import { Button, styled } from "@mui/material";
import { palette } from "../../themes/theme";

const DarkPrimaryButton = (props) => {
  return (
    <CustomButton {...props}>
      <span>{props.children}</span>
    </CustomButton>
  );
};

const CustomButton = styled(Button)(({ theme, variant }) => ({
  minWidth: 0,
  background: "black",
  textTransform: "capitalize",
  transition: "all 0.35s ease-in-out",
  position: "relative",
  overflow: "hidden",
  border: `1px solid ${palette.text.white60}`,
  padding: "5px 10px",
  borderRadius: "4px",
  "&:before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: 0,
    height: "100%",
    backgroundColor: theme.palette.primary.hover,
    transition: "all 0.35s ease-in-out",
  },
  "&:hover:before": {
    width: "100%",
  },
  span: {
    position: "relative",
    zIndex: 1,
    fontWeight: "bold",
    color: "white",
  },
  "&:hover": {
    span: {
      color: "white",
      transition: "all 0.35s ease-in-out",
    },
  },
}));

export default DarkPrimaryButton;
